import screenfull from 'screenfull'

export default {
  loadingGeolocation: false,
  pinchableViewer: false,
  customGeolocationRequired: true, // TODO: remove definitively tests #SDEU-35
  fullscreen: {
    supported: screenfull.enabled || false,
    active: false,
  },
}
